<template>
    <div id="processManage">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ titleData.formTitle }}<span>流程进度</span></h2>
                    <!--<p>发布时间：{{ titleData.createDate ? titleData.createDate.split(' ')[0] : '' }}</p>-->
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <el-tabs v-model="activeName" >
                <el-tab-pane v-for="(list,index) in horizontalStepList" :label="getLabel(index)" :name="''+index" :key="index" class="stepTab">
                    <el-row class="btns">
                        <el-button type="primary" v-show="active == 0 && littleStatus == 1" @click="toReply">回复邀请函</el-button>
                        <el-button type="primary" v-show="active == 2 " @click="toDownload(1)"><i class="downloadIcon"></i>下载标书</el-button>
                        <el-button type="primary" v-show="active == 3 && littleStatus > 4 " @click="toQuestions"><i class="problemIcon"></i>质疑/答疑</el-button>
                        <el-button type="primary" v-show="active == 3 && (list.actionStatus == 2 || list.actionStatus == 6 || list.actionStatus == 8 || list.actionStatus == 10) " @click="toBackStandard(list.id,list.actionStatus,1)"><i class="backStandardIcon"></i>{{ getText(list.actionStatus) }}</el-button>
                        <!--<el-button type="primary" v-show="active == 3 && (littleStatus == 6 || littleStatus == 7)" @click="toDownload(2)"><i class="downloadIcon"></i>二轮标书下载</el-button>-->
                        <el-button type="primary" v-show="active == 3 && littleStatus != 4" @click="toTender"><i class="bidReplyIcon"></i>询标回复</el-button>
                        <el-button type="primary" v-show="active == 5" @click="toLetter" class="winLetter">中标通知书/感谢信</el-button>
                    </el-row>
                    <!--<el-steps :active="active" finish-status="success" class="horizontalStep">-->
                    <el-steps :active="active" :finish-status="status" class="horizontalStep" align-center>
                        <el-step title="回复邀请函"></el-step>
                        <el-step title="发标"></el-step>
                        <el-step title="标书下载"></el-step>
                        <el-step title="回标"></el-step>
                        <el-step title="定标"></el-step>
                    </el-steps>
                    <section class="process">
                        <h2 class="progressTitle">流程进度</h2>
                        <ul class="ownSteps">
                            <li v-for="(item,i) in list.historyComments" :key="i">
                                <div class="dateStep">
                                    <p>{{ item.createDate }}</p>
                                </div>
                                <div class="clockStep">
                                    <img src="../../../assets/images/backStandard/clock.png"/>
                                    <strong class="progress" v-if="item.actionStatus == 2">终止</strong>
                                    <strong class="over" v-else >完成</strong>
                                    <p class="processLine"></p>
                                </div>
                                <div class="textStep">
                                    <h3>{{ item.nodeName }}<a href="javascript:;" class="view" v-if="showView(item)" @click="toView(item,list)">查看</a></h3>
                                    <p>状态：{{ item.actionName}}</p>
                                    <p class="timeT" v-show="item.modelType == 26 || item.modelType == 27">下载日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 19">发标日期：{{  item.updateDate  ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 18">回复日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 24">定标日期：{{  item.updateDate ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 20">回标日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 21">二轮回标日期：{{  item.updateDate  ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 22">商务谈判日期：{{  item.updateDate ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 23">评标约谈日期：{{  item.updateDate  ?  item.updateDate.split(' ')[0] : '' }}</p>
                                </div>
                                <div class="timeStep">
                                    <!--<p v-show="item.modelType == 22">{{ dateData.businessNegoteReturnDelay ? '商务谈判延标截止时间：'+ dateData.businessNegoteReturnDelay : ''}}</p>-->
                                    <p v-show="item.modelType == 22">{{ dateData.businessNegoteReturn ? '商务谈判截止时间：'+dateData.businessNegoteReturn : ''}}</p>
                                    <!--<p v-show="item.modelType == 23">{{ dateData.bidEvaluationDelay ? '评标延标截止时间：'+ dateData.bidEvaluationDelay : '' }}</p>-->
                                    <p v-show="item.modelType == 23">{{ dateData.bidEvaluation ? '评标截止时间：'+dateData.bidEvaluation : '' }}</p>
                                    <!--<p v-show="item.modelType == 21">{{ dateData.twoRoundBackBidDelay ? '二轮回标延标截止时间：'+dateData.twoRoundBackBidDelay : '' }}</p>-->
                                    <p v-show="item.modelType == 25 || item.modelType == 27">{{ dateData.twoRoundBackBid ? '二轮回标截止时间：'+ dateData.twoRoundBackBid : ''}}</p>
                                    <p v-show="item.modelType == 20">{{ dateData.questions ? '质疑截止时间：'+dateData.questions : ''}}</p>
                                    <p v-show="item.modelType == 20">{{ dateData.answers ? '答疑截止时间：'+dateData.answers : ''}}</p>
                                    <!--<p v-show="item.modelType == 20">{{ dateData.backBidDelay ? '回标延期截止时间：'+dateData.backBidDelay : '' }}</p>-->
                                    <p v-show="item.modelType == 19 || item.modelType == 26">{{ dateData.backBid ? '回标截止时间：'+ dateData.backBid : ''}}</p>
                                </div>
                            </li>
                        </ul>
                    </section>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import MyHeader from '../MasterHeader.vue'
    import axios from 'axios'
    export default {
        name: 'master-processManagement',
        data() {
            return {
                activeName: '0',//el-tab-pane的activeName
                active: 0,// steps步骤条
                id: '',//当前的列表项id
                status: 'success',//结束状态是成功还是失败 还是进行中
                statusList: [],//状态节点名称列表
                littleStatus: '',//小状态，判断按钮的显示隐藏；
                titleData: {},//其他标题
                horizontalStepList: [],//有几个标段，及具体数据
                dateData: {
                   /* businessNegoteReturnDelay: '',
                    businessNegoteReturn: '',
                    bidEvaluationDelay: '',
                    bidEvaluation: '',
                    twoRoundBackBidDelay: '',
                    twoRoundBackBid: '',
                    questions: '',
                    answers: '',
                    backBidDelay: '',
                    backBid: ''*/
                }//全部日期
            }
        },
        components: {
            MyHeader
        },
        created(){
            this.$root.activeIndex = 'win';
            this.id = this.$route.params.id;
            this.getStatus();//获取状态节点名称 及初始化数据
        },
        methods: {
            getLabel(i){
                if (i == 0){
                    return '标段一';
                } else if(i == 1) {
                    return '标段二';
                } else if(i == 2) {
                    return '标段三';
                }
            },
            getStatus(){//获取状态节点名称
                let _this = this;
                _this.$root.getHttp('/v1/sysDict/selectMap?type=tender_management_outer',function (res){
                    _this.statusList = res.data.data;
                    _this.getDetail(_this);
                });
            },
            getDetail(that){
                that.$root.getHttp('/v1/outerformflow/purchaseItemDetail?id='+ that.id,function (res) {
                    that.littleStatus = res.data.data.flowFormExtMng.flowFormSubStatus;
                    if((res.data.data.flowFormExtMng.flowFormStatus==1 && that.littleStatus == 2 ) || res.data.data.flowFormExtMng.flowFormStatus == 5){
                        that.active = parseInt(res.data.data.flowFormExtMng.flowFormStatus);
                    } else {
                        that.active = parseInt(res.data.data.flowFormExtMng.flowFormStatus) -1;
                    }
                    that.titleData = res.data.data.flowFormExtMng;
                    that.horizontalStepList = res.data.data.flowFormExtSubMngs;
                    that.dateData = res.data.data.wflowFormTimeNode || {};

                    if(that.active == 3){
                        for(var i = 0;i < that.horizontalStepList.length;i++) {
                            if(that.horizontalStepList[i].actionStatus == 2 || that.horizontalStepList[i].actionStatus == 6 || that.horizontalStepList[i].actionStatus == 8 || that.horizontalStepList[i].actionStatus == 10){
                                that.activeName = i+'';
                                break;
                            }
                        };
                    }
                })
            },
            getText(status){
                if(status == 2){
                    return '回  标';
                } else if(status == 6){
                    return '二轮回标';
                } else if(status == 8){
                    return '商务谈判';
                } else if(status == 10){
                    return '评标约谈';
                }
            },
            showView(val){//显示 垂直steps的查看按钮；
                if(val.modelType == 19 || val.modelType == 24 || val.modelType == 25){
                    return false;
                } else {
                    return true;
                }
            },
            toReply(){
                this.$router.push('/master/replyInvite/'+this.titleData.flowFormId+'/'+1);
            },
            toDownload(type){
                this.$router.push('/master/downloadDoc/'+this.titleData.flowFormId+'/'+1);
            },
            toQuestions(){
                this.$router.push('/master/questions/'+this.titleData.flowFormId+'/'+1);
            },
            toBackStandard(id,status,entrance,type){
//                entrance 入口(1:回标处理入口，2回标历史入口)
                let that = this;
                this.$root.postHttp('/v1/outerformflow/backBid/detail',{
                    formId: this.titleData.flowFormId,
                    subId: id,
                    entrance: entrance,
                    historyType: type || ''
                },function (res) {
//                    console.log(res)
                    window.sessionStorage.setItem('backStandardData',JSON.stringify(res.data.data));
                    that.$router.push('/master/backStandard/'+that.titleData.flowFormId+'/'+id+'/'+entrance+'/'+status);
                })
            },
            toTender(){
                this.$router.push('/master/replyTender/'+this.titleData.flowFormId+'/'+1);
            },
            toLetter(){
                this.$router.push('/master/letter/'+this.titleData.flowFormId+'/'+1);
            },
            toView(item,list){
//                console.log(item)
                if(item.modelType == 18){//回复邀请函
                    this.$router.push('/master/replyInvite/'+this.titleData.flowFormId+'/'+2);
                } else if(item.modelType == 26){//标书下载
                    this.$router.push('/master/downloadDoc/'+this.titleData.flowFormId+'/'+2);
                /*} else if(item.modelType == 27){//二轮标书下载
                    this.$router.push('/master/downloadDoc/'+this.titleData.flowFormId+'/'+2);*/
                } else if(item.modelType == 20) {//回标
//                    console.log(list)
                    this.toBackStandard(list.id,2,2,item.modelType);
                } else if(item.modelType > 20 && item.modelType <= 23){//二轮回标 商务谈判 评标约谈
                    this.toBackStandard(list.id,list.actionStatus,2,item.modelType);
                }
            },
        }
    }
</script>
<style lang="scss">
    @import "../../../assets/_var.scss";
    #processManage {
        padding-bottom: 50px;
        background: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        .banner {
            margin-top: 80px;
            img {
                width: 100%;
            }
            .main-container {
                position: relative;
                .bannerText {
                    position: absolute;
                    left: 0;
                    top: -50px;
                    width: 100%;
                    color: #fff;
                    line-height: 34px;
                    h2 {
                        float: left;
                        font-size: 18px;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            border: 1px solid #fff;
                            padding: 0 8px;
                            margin-left: 15px;
                            height: 24px;
                            font-size: 14px;
                            line-height: 22px;
                            border-radius: 4px;
                            font-weight: normal;
                            box-sizing: border-box;
                        }
                    }
                    p {
                        float: right;
                        font-size: 14px;
                    }
                }
            }
        }
        .mainWrap {
            position: relative;
            margin-top: 40px;
            .el-tabs__content {
                position: static;
            }
        }
        .btns {
            position: absolute;
            right: 40px;
            top: 10px;
            text-align: left;
            z-index: 2;
            .el-button {
                padding: 8px 5px;
                border-radius: 17px;
                min-width: 100px;
                height: 34px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/backStandard/icon01.png') no-repeat;
                }
                .problemIcon {
                    background: url('../../../assets/images/backStandard/icon02.png') no-repeat;
                }
                .backStandardIcon {
                    background: url('../../../assets/images/backStandard/icon03.png') no-repeat;
                }
                .bidReplyIcon {
                    background: url('../../../assets/images/backStandard/icon04.png') no-repeat;
                }
            }
            .winLetter {
                padding: 8px 10px;
            }
        }
        /*流程进度*/
        .process {
            width: 1100px;
            margin: 0 auto;
        }
        .progressTitle {//进度标题
            text-align: left;
            line-height: 58px;
            text-indent: 18px;
            background: $--primary-fill-color;
        }
        /*自己写的进度条，垂直方向*/
        .ownSteps {
            margin: 30px 0 50px;
              li {
                  overflow: hidden;
                  padding: 0 20px;
                  /*padding: 10px 20px 15px;*/
                  min-height: 94px;
                  box-sizing: border-box;
                  text-align: left;
                  &>div {
                      /*float: left;*/
                      display: inline-block;
                      vertical-align: middle;
                  }
                  & .dateStep {
                      font-size: 14px;
                      color:$--text-color-lighter;
                      p {
                          width: 78px;
                          white-space: normal;
                          word-break: break-all;
                          line-height: 26px;
                      }
                  }
                  & .clockStep {
                      position: relative;
                      img {
                          vertical-align: middle;
                          width: 38px;
                          height: 38px;
                      }
                      strong {
                          display: inline-block;
                          vertical-align: middle;
                          width: 72px;
                          height: 34px;
                          font-size: 14px;
                          text-align: center;
                          color: #fff;
                          font-weight: 400;
                          line-height: 34px;
                      }
                      .over {
                          background: url('../../../assets/images/backStandard/1.png') no-repeat;
                      }
                      .progress {
                          background: url('../../../assets/images/backStandard/2.png') no-repeat;
                      }
                      .processLine {
                          margin-left: 19px;
                          margin-top: -2px;
                          width: 3px;
                          height: 60px;
                          background: $--secondary-fill-color;
                      }
                  }
                  & .textStep {
                      /*vertical-align: top;*/
                      margin-left: 10px;
                      width: 328px;
                      h3 {
                          font-size: 16px;
                          line-height: 26px;
                          .view {
                              margin-left: 8px;
                              padding: 0 8px;
                              font-size: 12px;
                              color: #fff;
                              background: #4087e0;
                              border-radius: 12px;
                              line-height: 24px;
                              font-weight: normal;
                              text-decoration: none;
                          }
                      }
                      p {
                          font-size: 14px;
                          line-height: 24px;
                      }
                      .timeT {
                          color: $--text-color-lighter;
                      }
                  }
                  & .timeStep {
                      margin-bottom: 10px;
                      vertical-align: bottom;
                      font-size: 14px;
                      color: $--text-color-lighter;
                      line-height: 24px;
                  }
              }
            li:nth-of-type(even){
                background: $--primary-fill-color;
            }
            li:nth-of-type(odd){
                background: #fff;
            }
          }
        .el-tabs {
            background: #fff;
            /*padding-top: 20px;*/
            & .el-tabs__header {
                margin: 0 0 10px;
            }
            & .el-tabs__nav {
                margin-left: 40px;
            }
            & .el-tabs__item {
                font-size: 14px;
                height: 50px;
            }
            & .el-tabs__item.is-active {
                color: $--text-color;
                font-weight: 700;
            }
            & .el-tabs__active-bar {
                bottom: -2px;
                height: 12px;
                background: url('../../../assets/images/register/at.png') no-repeat center 0;
            }
            & .el-tabs__nav-wrap::after {
                height: 1px;
                background-color: $--secondary-fill-color;
            }
        }
        .stepTab{
            .horizontalStep {
                margin: 50px auto;
                .el-step__title {
                    font-size: 14px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ProcessManage.vue